import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#1A1A1A] text-white py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            
            
            <div className="flex space-x-4 space-x-reverse justify-center">
              <a href="https://www.facebook.com/profile.php?id=61581894786315&mibextid=wwXIfr&rdid=khDbBeSPvVMfax7T&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1KS1edbGsC%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/sz_lawyers?igsh=MWU2YjRybW0yMDhqaQ%3D%3D" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-lg font-medium mb-4">קישורים</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-gray-300 hover:text-white transition-colors">
                  מדיניות פרטיות
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-gray-300 hover:text-white transition-colors">
                  תנאי שימוש
                </Link>
              </li>
              <li>
                <Link to="/data-rights" className="text-sm text-gray-300 hover:text-white transition-colors">
                  זכויות נפגע
                </Link>
              </li>
              <li>
                <button onClick={() => {
                localStorage.removeItem('cookieConsent');
                window.location.reload();
              }} className="text-sm text-gray-300 hover:text-white transition-colors text-right">
                  העדפות קוקיז
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-lg font-medium mb-4">צור קשר</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <MapPin size={18} className="mt-1 ml-2 flex-shrink-0" />
                <p className="text-sm text-gray-300">ביג פאשן גלילות, כביש החוף, רמת השרון</p>
              </div>
              <div className="flex items-center">
                <Phone size={18} className="ml-2 flex-shrink-0" />
                <a href="tel:+97231234567" className="text-sm text-gray-300 hover:text-white transition-colors">03-3752886</a>
              </div>
              <div className="flex items-center">
                <Mail size={18} className="ml-2 flex-shrink-0" />
                <a href="mailto:info@benzur.co.il" className="text-sm text-gray-300 hover:text-white transition-colors">office@szlaw.co.il</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-gray-800 text-center text-xs text-gray-500">
          <p>© {new Date().getFullYear()} סמירנוב צולר משרד עורכי דין. כל הזכויות שמורות.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;